/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';

declare let jQuery: any;

@Component({
  selector: 'app-ctv-brandsafety',
  templateUrl: './ctv-brandsafety.component.html',
  styleUrls: [
    './ctv-brandsafety.component.scss',
    '../../details-page/details-item.css',
    '../../details-page/label-styles.css'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CtvBrandsafetyComponent implements OnInit {
  @Input() os;
  @Input() data;
  @Input() isFreemium: boolean;
  @Output() anchorClick = new EventEmitter<string>();

  currentOpenImageUrl: string;
  tooltipTemplate =
    '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner email"></div></div>';

  ngOnInit() {
    jQuery('[data-toggle="tooltip"]').tooltip({ animation: false });
  }

  toggleAccordion(item: any) {
    if (this.currentOpenImageUrl !== item.url) {
      this.currentOpenImageUrl = item.url;
    } else {
      this.currentOpenImageUrl = null;
    }
  }

  goToSection(anchor: string) {
    this.anchorClick.emit(anchor);
  }
}
